var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "ai-knowledge" }, [
    _c(
      "div",
      { staticClass: "header" },
      [
        _c("span", { staticClass: "story-name" }, [
          _vm._v(_vm._s(_vm.storyTitle) + " "),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "search-wrapper" }, [
          _c("div", { staticClass: "tpl-search" }, [
            _c("i", { staticClass: "material-icons" }, [_vm._v("search")]),
            _vm._v(" "),
            _c("input", {
              attrs: { type: "text", placeholder: _vm.$t("message.search") },
            }),
          ]),
        ]),
        _vm._v(" "),
        _c(
          "IconButton",
          {
            attrs: {
              "on-click": function () {
                return _vm.$emit("close")
              },
            },
          },
          [_c("i", { staticClass: "material-icons" }, [_vm._v("close")])]
        ),
      ],
      1
    ),
    _vm._v(" "),
    _c("div", { staticClass: "page-content" }, [
      _c("div", { staticClass: "sidebar" }, [
        _c("div", { staticClass: "first" }, [
          _c(
            "div",
            {
              staticClass: "d-flex justify-content-between align-items-center",
            },
            [
              _c("div", { staticClass: "d-flex align-items-center gap-5" }, [
                _c("i", { staticClass: "material-icons" }, [
                  _vm._v("auto_awesome"),
                ]),
                _vm._v(" "),
                _c("strong", [_vm._v(_vm._s(_vm.$t("chatbotv2.aiKnowledge")))]),
              ]),
              _vm._v(" "),
              _c("IconButton", [
                _c("i", { staticClass: "material-icons" }, [
                  _vm._v("help_outline"),
                ]),
              ]),
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "menu-items" }, [
            _c(
              "div",
              {
                staticClass: "menu-item",
                class: { selected: _vm.currentPage === "websites" },
                on: {
                  click: function ($event) {
                    _vm.currentPage = "websites"
                  },
                },
              },
              [
                _c("span", [_vm._v(_vm._s(_vm.$t("chatbotv2.websites")))]),
                _vm._v(" "),
                _c("span", { staticClass: "value" }, [
                  _vm._v(_vm._s(_vm.knowledgeBaseTotal.webpage)),
                ]),
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "menu-item",
                class: { selected: _vm.currentPage === "articles" },
                on: {
                  click: function ($event) {
                    _vm.currentPage = "articles"
                  },
                },
              },
              [
                _vm._v(
                  "\n                        " +
                    _vm._s(_vm.$t("chatbotv2.articles")) +
                    "\n                        "
                ),
                _c("span", { staticClass: "value" }, [
                  _vm._v(_vm._s(_vm.knowledgeBaseTotal.article)),
                ]),
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "menu-item",
                class: { selected: _vm.currentPage === "faq" },
                on: {
                  click: function ($event) {
                    _vm.currentPage = "faq"
                  },
                },
              },
              [
                _vm._v(
                  "\n                        " +
                    _vm._s(_vm.$t("chatbotv2.faq")) +
                    "\n                        "
                ),
                _c("span", { staticClass: "value" }, [
                  _vm._v(_vm._s(_vm.knowledgeBaseTotal.faq)),
                ]),
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "menu-item",
                class: { selected: _vm.currentPage === "files" },
                on: {
                  click: function ($event) {
                    _vm.currentPage = "files"
                  },
                },
              },
              [
                _vm._v(
                  "\n                        " +
                    _vm._s(_vm.$t("chatbotv2.files")) +
                    "\n                        "
                ),
                _c("span", { staticClass: "value" }, [
                  _vm._v(_vm._s(_vm.knowledgeBaseTotal.file)),
                ]),
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "menu-item",
                class: { selected: _vm.currentPage === "functions" },
                on: {
                  click: function ($event) {
                    _vm.currentPage = "functions"
                  },
                },
              },
              [
                _vm._v(
                  "\n                        " +
                    _vm._s(_vm.$t("chatbotv2.functions")) +
                    "\n                        "
                ),
                _c("span", { staticClass: "value" }, [
                  _vm._v(_vm._s(_vm.knowledgeBaseTotal.aiFunction)),
                ]),
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "menu-item",
                class: { selected: _vm.currentPage === "settings" },
                on: {
                  click: function ($event) {
                    _vm.currentPage = "settings"
                  },
                },
              },
              [
                _vm._v(
                  "\n                        " +
                    _vm._s(_vm.$t("chatbotv2.settings")) +
                    "\n                        "
                ),
                _c("span", { staticClass: "value" }, [
                  _vm._v(_vm._s(_vm.files.length)),
                ]),
              ]
            ),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "second" }, [
          _c(
            "div",
            { staticClass: "d-flex align-items-center gap-5" },
            [
              _c("IconButton", [
                _c("i", { staticClass: "material-icons" }, [
                  _vm._v("help_outline"),
                ]),
              ]),
              _vm._v(" "),
              _c("strong", [_vm._v(_vm._s(_vm.$t("chatbotv2.modalUsage")))]),
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "stats" }, [
            _c("div", { staticClass: "value" }, [
              _c("strong", [
                _vm._v(
                  _vm._s(
                    _vm.knowledgeBaseTotal.article +
                      _vm.knowledgeBaseTotal.faq +
                      _vm.knowledgeBaseTotal.webpage +
                      _vm.knowledgeBaseTotal.file +
                      _vm.knowledgeBaseTotal.aiFunction
                  )
                ),
              ]),
              _vm._v(" "),
              _c("span", [_vm._v("/ 1000")]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "description" }, [
              _vm._v(_vm._s(_vm.$t("chatbotv2.usedContentSources"))),
            ]),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _vm.currentPage === "websites"
        ? _c(
            "div",
            { staticClass: "content" },
            [
              _c("Websites", {
                attrs: { storyId: _vm.storyId },
                on: { trained: _vm.trained },
              }),
            ],
            1
          )
        : _vm.currentPage === "articles"
        ? _c(
            "div",
            { staticClass: "content" },
            [_c("Articles", { attrs: { storyId: _vm.storyId } })],
            1
          )
        : _vm.currentPage === "faq"
        ? _c(
            "div",
            { staticClass: "content" },
            [_c("FaqList", { attrs: { "story-id": _vm.storyId } })],
            1
          )
        : _vm.currentPage === "files"
        ? _c(
            "div",
            { staticClass: "content" },
            [
              _c("KBFiles", {
                attrs: { "story-id": _vm.storyId },
                on: {
                  updated: function (items) {
                    return (_vm.files = items)
                  },
                },
              }),
            ],
            1
          )
        : _vm.currentPage === "functions"
        ? _c(
            "div",
            { staticClass: "content" },
            [
              _c("FunctionList", {
                attrs: { "story-id": _vm.storyId },
                on: {
                  updated: function (items) {
                    return (_vm.files = items)
                  },
                },
              }),
            ],
            1
          )
        : _vm.currentPage === "settings"
        ? _c(
            "div",
            { staticClass: "content" },
            [_c("ChatbotAiPrompt", { attrs: { storyId: _vm.storyId } })],
            1
          )
        : _vm._e(),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }